<template>
    <div class="route-status content-wrapper">
        <div class="header-title">
            <span class="header-title-block"></span>
            <span class="header-title-txt">链路信息</span>
            <span class="info-header-icon" @click="showLog">log</span>
        </div>
        <el-divider></el-divider>
        <div class="route-status-content">
            <!-- <div class="route-status-info">
                <div class="status-active" @dblclick="copyItem($event)">{{linkData.taskStatusName}}</div>
                <div @dblclick="copyItem($event)">{{linkData.taskNo}}</div>
                <div @dblclick="copyItem($event)">{{linkData.createTime}}</div>
            </div> -->
            <div class="link-process">
                <div class="link-process-item" v-for="(item, index) in linkInfo" :key="index" :style="'width:'+(100/(linkInfo.length))+'%'">
                    <div class="link-process-content">
                        <div class="link-process-icon" :style="'background-image:url('+(item.isShow=== 1 ? active : notActive)+')'"></div>
                        <div class="link-process-name" @dblclick="copyItem($event)">{{item.taskStatusName}}</div>
                        <div class="link-process-time" @dblclick="copyItem($event)">{{ item.operationTime }}</div>
                    </div>
                    <div class="link-process-point">
                        <span class="arrow" :class="linkInfo[index] && linkInfo[index].isShow === 1 ? 'active' : 'notActive'"></span>
                        <span class="bigPoint" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'point-active ' : 'point-not-active'"></span>
                        <span class="arrow" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'active' : 'notActive'"></span>
                        <i class="el-icon-arrow-right" :class="linkInfo[index+1] && linkInfo[index+1].isShow === 1 ? 'right-active' : 'right-not-active'"></i>
                    </div>
                </div>
            </div>
        </div>
        <operation-node-log
            ref="operationNodeLog"
            v-if="isShowOperationNodeLog"
            :isShowOperationNodeLog.sync="isShowOperationNodeLog"
            :taskNo="taskNo"
            :dictData="dictData"
            :componentsData="componentsData"
        ></operation-node-log>
    </div>
</template>

<script>
import { copyToClip } from '../util.js';
import bigDataLog from '@/utils/bigDataLog';
import OperationNodeLog from '../../../../distributeManage/dispatchMgmt/components/operationNodeLog/Index.vue';
export default {
    name: 'LinkInformation',
    components: { OperationNodeLog },
    props: {
        linkData: {
            type: Object,
            default: () => {
                return {};
            }
        },
        componentsData: {
            type: Object,
            default () {
                return {};
            }
        },
        dictData: {
            type: Object,
            default () {
                return {};
            }
        },
        taskNo: {
            type: String,
            default: ''
        }
    },
    data () {
        return {
            active: require('@/assets/carActive.png'),
            notActive: require('@/assets/carNotActive.png'),
            linkInfo: [],
            isShowOperationNodeLog: false
        };
    },
    methods: {
        copyItem (e) {
            const value = (e.target.innerHTML).trim();
            copyToClip(value);
        },
        showLog () {
            bigDataLog.sendDetailMessageByKey('bigData-btn-task-log');
            this.isShowOperationNodeLog = true;
        }
    },
    watch: {
        linkData: {
            handler (newValue, oldValue) {
                this.linkInfo = newValue.list || [];
            },
            deep: true,
            immediate: true
        }
    }
};
</script>
